import { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { t } from '../utils/i18n'
import { disclaimerClicked } from '../actions'

const Modal = ({ type, method = () => {} }) => {
  const dispatch = useDispatch()
  const componentId = useSelector((state) => state.options.componentId)
  const [disabled, setDisabled] = useState(false)

  const handleClick = () => {
    setDisabled(true)
    dispatch(disclaimerClicked())
    method()
  }

  let delayContent = (
    <p>
      When ordering custom-designed bikes, please expect a delivery time of
      approximately 6-10 weeks, depending on the season - (Note: possibility for
      express delivery in about 3-4 weeks - see details and prices in the
      checkout).
    </p>
  )

  if (window.location.hostname.endsWith('.dk'))
    delayContent = (
      <p>
        Ved bestilling af specialdesignede cykler forventes en leveringstid på
        ca. 6-10 uger afhængig af sæson - (obs: mulighed for express levering på
        ca. 3-4 uger - se detaljer og priser i checkout)
      </p>
    )
  if (window.location.hostname.endsWith('.de'))
    delayContent = (
      <p>
        Beim Bestellen von individuell gestalteten Fahrrädern beträgt die
        Lieferzeit ca. 6-10 Wochen, je nach Saison. (Hinweis: Es besteht die
        Möglichkeit einer Expresslieferung in ca. 3-4 Wochen - Details und
        Preise finden Sie im Checkout).
      </p>
    )

  return (
    <div className="vel-modal">
      {type === 'delay' ? (
        <>{delayContent}</>
      ) : (
        <>
          <div className="vel-modal-header">{t('colours')}</div>
          <p>
            {t(
              `color_disclaimer${
                componentId === 'electric-motor' ? '_battery' : ''
              }`
            )}
          </p>
        </>
      )}

      <button
        className="vel-accept-button"
        onClick={handleClick}
        disabled={disabled}
      >
        {t(`${type === 'delay' ? 'delay_button' : 'accept'}`)}
      </button>
    </div>
  )
}

export default Modal
